module.exports=function(scope){ return `<label class="mdl-radio mdl-js-radio ${scope.cls}" for="${scope.id}-input" ${scope.attrs}>
    <input id="${scope.id}-input" class="mdl-radio__button" type="radio" name="${scope.name}" value="${scope.value}" ${scope.checked}>
    <span class="mdl-radio__label">${scope.label}</span>
</label>`};